<template lang="html">

	<footer class="footer">

		<div class="footer-container row-between" :withoutMT="withoutMT">
			<section class="coorporative">
				<span>Formamos parte del grupo educativo de:</span>
				<img src="/static/img/brands/galeno/logo-pie.svg" alt="Grupo UAX">

			</section>

			<nav class="row-center container-links" v-if="!!links">

				<template v-for="(data, key) in links">

					<a :href="data" target="_blank">{{ key }}</a>

				</template>

				<idioma v-if="brand.languagebydefault"></idioma>
				<div class="top row-center">
					<template v-for="t in texts" v-if="!!texts">
						<p v-html="t"></p>
					</template>
				</div>
			</nav>




		</div>

		<p class="version">v.{{ version }}</p>


	</footer>

</template>

<script lang="js">

import { mapGetters } from 'vuex';


import idioma from '@/components/parts/idioma';

export default {
	name: 'app-footer',
	computed: {
		...mapGetters({
			colors: 'basicColors',
			texts: 'getFooterText',
			links: 'getFooterLinks',
			version: 'getVersion',
			brand: 'getBrand'

		}),
		ownstyles: function () {
			return {
				bgWhite: {
					background: this.colors.white
				}
			}
		},
		withoutMT: function () {
			let views = [
				'/login',
				'/login/empresas',
				'/login/antiguos',
				'/login/alumnos',
				'/mantenimiento',
				'/acceso',
				'/gma2019',
			];
			return (views.some(el => el == this.$route.path));
		}
	},
	components: {
		'idioma': idioma
	}
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/parts/footer.vue